import React from "react";
import "./Program_Of_Lessons.css";
import Play_New_Lottie from "../../animation/play_lottie/Play_New_Lottie";
import { IDS } from '../../../utils/IDS';
import parse from "html-react-parser";

const Program_Of_Lessons = ({ about_us }) => {

  const videoRef = React.useRef(null);

  const handlePlayPause = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  };

  return (
    <section className="Program_Of_Lessons">
      <div className="container">
        <div className="descn_div">
          <p className="descn_text">
            {parse(about_us?.About_U?.content || "")}
          </p>
        </div>

        <div className="content_holder">
          <div className="vdo_img_holder">
            <video
              ref={videoRef}
              className="bg_img"
              src={`${IDS.IMG_URL + about_us?.About_U?.video}`}
              muted
              autoPlay
              loop
              controls
            />
            {/* <img
              src="/assets/images/about_us/program_of_lessons/bg.png"
              className="bg_img"
            /> */}
          </div>
          <div className="play_lottie_holder" onClick={handlePlayPause}>
            <Play_New_Lottie />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Program_Of_Lessons;

